import React from 'react'
import { Head } from '../components/Head'

const Privacy = () => {
	return (
		<>
			<Head
				title="プライバシーポリシー"
				description="ナガタクのプライバシーポリシーページです。ナガタクでは和食・中華・韓国料理・カレー・イタリアン・コーヒー・ケーキ・お酒など様々なジャンルのお店全店舗自由に組み合わせて注文可能です。"
				image="https://www.nagataku.com/logo2.svg"
			/>
			<div className="p-6 md:w-[686px] mx-auto">
				<div className="mb-4">最終改定日: 2021年11月1日</div>
				<div className="font-bold">
					「ナガタク」（以下「本サービス」といいます）を運営する合同会社サントラスト（以下「当社」といいます）は、本サービスのユーザー及びユーザー登録希望者（以下「ユーザー等」といいます）の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます）を遵守すると共に、以下のプライバシーポリシー（以下「本プライバシーポリシー」といいます）に従い、適切な取扱い及び保護に努めます。
				</div>

				<div className="flex my-4">
					<div className="mr-2">1.</div>
					<div>
						本プライバシーポリシーにおいて、個人情報とは、個人情報保護法の定義に従うものとし、その他の定義については、ナガタク利用規約及びナガタク出店規約（以下「利用規約」といいます）に従うものとします。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">2.</div>
					<div>
						当社は、利用規約に基づき、以下の個人情報を収集し、利用目的に従って利用いたします。
						<div className="flex">
							<div className="mr-2">(1)</div>
							<div>
								<div>ユーザー等からの取得</div>
								<div>
									<div>① 取得情報</div>
									<div className="flex">
										<div>・</div>
										<div>
											ユーザー等：氏名、住所、メールアドレス、電話番号等当社の定めた項目の情報
										</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>
											出店ユーザー：上記に加えて管理責任者の情報、金融機関口座、その他当社の求める情報
										</div>
									</div>
									<div>② 利用目的</div>
									<div className="flex">
										<div>・</div>
										<div>本サービスへのログイン、退会、登録情報変更等のため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>本サービスの提供及びユーザー等の管理のため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>購入ユーザーの情報を本人に代わって出店ユーザーに提供するため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>デリバリー商品を配達するため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>配達手数料、商品手数料、システム手数料等の請求管理のため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>本サービスに関するお問い合わせに関する内容確認又は返信のため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>分析、調査等を行いマーケティングに活用するため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>
											お得な情報（DM、広告）、大事なお知らせ（店舗及び当社の臨時休業やサービス条件変更など）を送付又は送信するため
										</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>ユーザー等に有用と思われる情報の告知、広告のため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>利用規約に基づく行為を行うため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>その他、通知または公表した利用目的のため</div>
									</div>
								</div>
							</div>
						</div>
						<div className="flex">
							<div className="mr-2">(2)</div>
							<div>
								<div>当社所定のお問合せフォーム等における取得</div>
								<div>
									<div>① 取得情報</div>
									<div className="flex">
										<div>・</div>
										<div>氏名、メールアドレス、問い合わせ本文等</div>
									</div>
									<div>② 利用目的</div>
									<div className="flex">
										<div>・</div>
										<div>お問い合わせ内容の検討及びユーザー等への返信のため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>当社のサービスの改善、新サービスの開発等に役立てるため</div>
									</div>
									<div className="flex">
										<div>・</div>
										<div>その他上記利用目的に付随する目的のため</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">3.</div>
					<div>
						当社は、個人情報保護法その他の法令により許容される場合を除き、ユーザー等の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
						<div className="flex">
							<div className="mr-2">(1)</div>
							<div>法令に基づく場合</div>
						</div>
						<div className="flex">
							<div className="mr-2">(2)</div>
							<div>
								人の生命、身体又は財産の保護のために必要がある場合であって、ユーザー等の同意を得ることが困難であるとき
							</div>
						</div>
						<div className="flex">
							<div className="mr-2">(3)</div>
							<div>
								公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ユーザー等の同意を得ることが困難であるとき
							</div>
						</div>
						<div className="flex">
							<div className="mr-2">(4)</div>
							<div>
								国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザー等の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
							</div>
						</div>
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">4.</div>
					<div>当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">5.</div>
					<div>
						当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理を図ると共に、当社の従業員及び関係者に対し、必要かつ適切な監督を行います。また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">6.</div>
					<div>
						購入ユーザーは、テイクアウト又はデリバリーのために、当社が購入ユーザーの情報について、本人に代わって出店ユーザーに提供することに同意するものとします。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">7.</div>
					<div>
						当社は、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめユーザー等の同意を得ないで、個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。
						<div className="flex">
							<div className="mr-2">(1)</div>
							<div>
								当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って個人情報を提供する場合
							</div>
						</div>
						<div className="flex">
							<div className="mr-2">(2)</div>
							<div>合併その他の事由による事業の承継に伴って個人情報が提供される場合</div>
						</div>
						<div className="flex">
							<div className="mr-2">(3)</div>
							<div>個人情報保護法の定めに基づき共同利用する場合</div>
						</div>
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">8.</div>
					<div>
						当社は、ユーザー等から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、ユーザー等ご本人からのご請求であることを確認の上で、ユーザー等に対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">9.</div>
					<div>
						当社は、ユーザー等から、個人情報が真実でないという理由によって、個人情報保護法の定めに基づきその内容の訂正、追加又は削除（以下「訂正等」といいます）を求められた場合には、ユーザー等ご本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨をユーザー等に通知します（訂正等を行わない旨の決定をしたときは、ユーザー等に対しその旨を通知いたします）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">10.</div>
					<div>
						当社は、ユーザー等から、ユーザー等の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止又は消去（以下「利用停止等」といいます）を求められた場合において、そのご請求に理由があることが判明した場合には、ユーザー等ご本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等を行い、その旨をユーザー等に通知します。但し、個人情報保護法その他の法令により、当社が利用停止等の義務を負わない場合は、この限りではありません。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">11.</div>
					<div>
						開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱い及び当社の氏名等に関するお問い合わせは、当社所定のお問合せフォーム等を通じて、当社までご連絡ください。
					</div>
				</div>

				<div className="flex my-4">
					<div className="mr-2">12.</div>
					<div>
						当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本プライバシーポリシーを変更することがあります。
					</div>
				</div>

				<div className="text-right">以上</div>
			</div>
		</>
	)
}

export default Privacy
